import { createFileRoute } from "@tanstack/react-router"
import { validateInstructorSectionSearch } from "@/utils/instructorSectionSearch"
import { queryClient } from "@/queryClient"
import { getCourseOptions, getProjectOptions } from "@/client/@tanstack/react-query.gen"
import ProjectAssessmentCreate from "@/routes/-pages/ProjectAssessmentCreate"
import { runBackendModePrefetch } from "@/utils/routePrefetch"

export const Route = createFileRoute("/instructor/course/$courseId/project/$projectId/assessment/create")({
  validateSearch: validateInstructorSectionSearch,
  loader: ({ params }) => {
    return runBackendModePrefetch(() =>
      Promise.all([
        queryClient.prefetchQuery(getCourseOptions({ path: { course_id: params.courseId } })),
        queryClient.prefetchQuery(getProjectOptions({ path: { project_id: params.projectId } })),
      ]),
    )
  },
  component: ProjectAssessmentCreate,
})
